import React from 'react'
import { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserPanelTitle from '../../Components/UserPanelTitle/UserPanelTitle'
import './Search.css'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import { useState } from 'react'
import { shuffle } from "lodash";
import ProductItem from '../../Components/ProductItem/ProductItem'
import UserPanelEmptyAlert from '../../Components/UserPanelEmptyAlert/UserPanelEmptyAlert'
import { MdOutlineRemoveShoppingCart } from 'react-icons/md'
import PaginationComponent from "../../Components/PaginationComponent/PaginationComponent";
import ArticleSliderItem from '../../Components/ArticleSliderItem/ArticleSliderItem'
import CoursesItem from '../../Components/CoursesItem/CoursesItem.'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Search() {
    const param = useParams('search');
    const category = useParams('category');
    const orderType = "RegisterDate";
    const [page, setPage] = useState(1);
    const [productList, setProductList] = useState([])
    const [productCount, setProductCount] = useState(0);
    const [CourseList, setCourseList] = useState([])
    const [courseCount, setCourseCount] = useState(0)
    const [blogList, setBlogList] = useState([])
    const [blogCount, setBlogCount] = useState(0);
    let itemsPerPage = 25;
    const colors = [
        "#7443FF",
        "#69B721",
        "#5F0101",
        "#7345FB",
        "#83CD1A",
        "#34ebe1",
        "#c034eb",
    ];
    const shuffledColors = shuffle(colors)
    useEffect(() => {
        getCourseData()
        getProductData()
        getBlogData()
    }, [param, category])
    const getCourseData = () => {
        axiosConfig
            .get(
                `api/Courses?page=${page}&pageSize=${itemsPerPage}&price=-1&orderBy=${orderType}` +
                (param.search !== undefined && param.search !== "" && param.search !== "all"
                    ? `&searchText=${param.search}${category.category != "all" ? `&category=${category.category}` : ""}`
                    : "") + (category.category !== undefined && category.category !== "" && category.category !== "all"
                        ? `&category=${category.category}`
                        : "")
            )
            .then((res) => {
                setCourseList(res.data.data);
                setCourseCount(res.data.count);
            });
    };
    const getProductData = () => {
        axiosConfig
            .get(
                `api/Products?page=${page}&pageSize=${itemsPerPage}&price=-1&orderBy=${orderType}` +
                (param.search !== undefined && param.search !== "" && param.search !== "all"
                    ? `&searchText=${param.search}`
                    : "") + (category.category !== undefined && category.category !== "" && category.category !== "all"
                        ? `&category=${category.category}`
                        : "")
            )
            .then((res) => {
                setProductList(res.data.data);
                setProductCount(res.data.count);
            });
    };
    const getBlogData = () => {
        if (param.search != "all")
            axiosConfig
                .get(
                    `api/Blog?page=${page}&pageSize=${itemsPerPage}&price=-1&orderBy=${orderType}` +
                    (param.search !== undefined && param.search !== "" && param.search !== "all"
                        ? `&searchText=${param.search}`
                        : "")
                )
                .then((res) => {
                    setBlogList(res.data.data);
                    setBlogCount(res.data.count);
                });
    };

    return (
        <>
            <Helmet>
                <title>جست‌وجوی تخصصی در دوره‌ها، مقالات و محصولات | سه‌نیک</title>
                <meta
                    name="description"
                    content="نتایج جست‌وجوی دقیق در میان ده‌ها محتوای آموزشی، دوره تخصصی، مقاله علمی و محصولات کاربردی در حوزه مدیریت تولید و صنایع. آنچه نیاز دارید در سه‌نیک پیدا کنید."
                />
            </Helmet>
            <div className='search-container'>
                <Container>
                    {
                        CourseList.length != 0 || blogList.length != 0 || productList.length != 0 ? (
                            <div className='search-box-wrapper'>
                                {
                                    CourseList.length != 0 ? (
                                        <div className='search-box-courses'>
                                            <UserPanelTitle title='دوره ها' />
                                            <div className='search-box-items-wrapper'>
                                                <Row>
                                                    {CourseList.map((item, index) => (
                                                        <Col md={6} lg={3}>
                                                            <div className="course-category-course-item">
                                                                <CoursesItem
                                                                    backgroundColor={
                                                                        shuffledColors[index]
                                                                    }
                                                                    item={item}
                                                                />
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                                <div className="d-flex justify-content-center mt-5 ltr">
                                                    <PaginationComponent
                                                        itemsCount={courseCount}
                                                        itemsPerPage={24}
                                                        currentPage={page}
                                                        setCurrentPage={setPage}
                                                        alwaysShown={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (null)
                                }

                                {
                                    productList.length != 0 ? (
                                        <div className='search-box-product'>
                                            <UserPanelTitle title='محصولات' />
                                            <div className='search-box-items-wrapper'>
                                                <Row>
                                                    {productList.map((item, index) => (
                                                        <Col md={6} lg={3}>
                                                            <div className="product-category-product-item">
                                                                <ProductItem
                                                                    backgroundColor={
                                                                        shuffledColors[index]
                                                                    }
                                                                    product={item}
                                                                />
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                                <div className="d-flex justify-content-center mt-5 ltr">
                                                    <PaginationComponent
                                                        itemsCount={productCount}
                                                        itemsPerPage={itemsPerPage}
                                                        currentPage={page}
                                                        setCurrentPage={setPage}
                                                        alwaysShown={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        null
                                    )
                                }
                                {
                                    blogList.length != 0 ? (
                                        <div className='search-box-blog'>
                                            <UserPanelTitle title='مقاله ها' />
                                            <div className='search-box-items-wrapper'>

                                                <>
                                                    <Row>
                                                        {blogList.map((item) => (
                                                            <Col lg={3}>
                                                                <div className="article-category-item">
                                                                    <ArticleSliderItem item={item} />
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                    <div className="d-flex justify-content-center mt-5 ltr">
                                                        <PaginationComponent
                                                            itemsCount={blogCount}
                                                            itemsPerPage={24}
                                                            currentPage={page}
                                                            setCurrentPage={setPage}
                                                            alwaysShown={true}
                                                        />
                                                    </div>
                                                </>

                                            </div>
                                        </div>
                                    ) : (null)
                                }
                            </div>
                        ) : (
                            <UserPanelEmptyAlert title='هیچ محصول و دوره ای پیدا نشده' icon={<MdOutlineRemoveShoppingCart />} />
                        )
                    }

                </Container>
            </div>
        </>

    )
}
